// extracted by extract-css-chunks-webpack-plugin
module.exports = {"activity":"activity_1SG20","title":"title_jgpri"};